import { useState } from 'react';
import { useKeycloak } from '../auth/KeycloakAuthProvider';
import { getExternalUrl } from '../config/urls';

interface IMenuItem {
  title: string;
  href: string;
  children?: IMenuItem[];
  icon?: string;
  isOpen?: boolean;
}

//Nur als Fallback, wenn der API-Call fehlschlägt oder keine Daten zurückliefert
const initialMenuItems: IMenuItem[] = [
  {
    title: "Seminare",
    href: getExternalUrl("/seminare"),
    children: [
      { title: "Suchen", href: getExternalUrl("/seminare/suchen") },
      { title: "Neue Seminare", href: getExternalUrl("/seminare/neue-seminare") },
      { title: "Kompaktkurse", href: getExternalUrl("/seminare/kompaktkurse") },
      { title: "Themenbereiche", href: getExternalUrl("/seminare/seminare-suchen-bereiche") },
      { title: "Anmeldung", href: getExternalUrl("/seminare/anmeldung") },
    ],
    isOpen: false,
  },
  {
    title: "E-Learning",
    href: getExternalUrl("/online-seminare"),
    children: [
      { title: "Webinare", href: getExternalUrl("/online-seminare/uebersicht") },
      { title: "Online-Coaching", href: getExternalUrl("/online-seminare/online-coaching") },
      { title: "Lernvideos", href: getExternalUrl("/lernvideos") },
    ],
    isOpen: false,
  },
  {
    title: "Inhouse",
    href: getExternalUrl("/inhouse-schulungen"),
    children: [
      {
        title: "Inhouse, was ist das?",
        href: getExternalUrl("/inhouse-schulungen/inhouse-was-ist-das"),
      },
      {
        title: "Unsere Inhouse-Kunden",
        href: getExternalUrl("/inhouse-schulungen/unsere-inhouse-kunden"),
      },
      {
        title: "Angebot anfordern",
        href: getExternalUrl("/inhouse-schulungen/angebot-anfordern"),
      },
      { title: "Unser Team", href: getExternalUrl("/inhouse-schulungen/unser-team") },
    ],
    isOpen: false,
  },
  {
    title: "Tagungen",
    href: getExternalUrl("/tagungen"),
    children: [
      { title: "Ausbildungsfachtag", href: getExternalUrl("/tagungen/ausbildungsfachtag") },
      { title: "Ausländerrecht", href: getExternalUrl("/tagungen/auslaenderrecht") },
      { title: "Beamtenrecht", href: getExternalUrl("/tagungen/beamtenrecht") },
      { title: "Betreuungsrecht", href: getExternalUrl("/tagungen/betreuungsrecht") },
      {
        title: "Bundeskonferenz der Gleichstellungsbeauftragten",
        href: getExternalUrl("/tagungen/bundeskonferenz-der-gleichstellungsbeauftragten"),
      },
      { title: "Bundesprüfertage ®", href: getExternalUrl("/tagungen/bundespruefertage") },
      { title: "Compliance", href: getExternalUrl("/tagungen/compliance") },
      { title: "Datenschutz", href: getExternalUrl("/tagungen/datenschutz") },
      {
        title: "Fachtag - Sexuelle Belästigung",
        href: getExternalUrl("/tagungen/sexuelle-belaestigung-am-arbeitsplatz"),
      },
      {
        title: "Gemeinnützigkeitsrecht",
        href: getExternalUrl("/tagungen/gemeinnuetzigkeitsrecht"),
      },
      { title: "Gleichstellung", href: getExternalUrl("/tagungen/gleichstellung") },
      { title: "Insolvenzrecht", href: getExternalUrl("/tagungen/insolvenzrecht") },
      { title: "Jugendhilfe", href: getExternalUrl("/tagungen/jugendhilfe") },
      { title: "Kommunalfinanzen", href: getExternalUrl("/tagungen/kommunalfinanzen") },
      { title: "Lohnpfändung", href: getExternalUrl("/tagungen/lohnpfaendung") },
      { title: "Messie-Syndrom", href: getExternalUrl("/tagungen/messie-syndrom") },
      { title: "Nachhaltigkeit", href: getExternalUrl("/tagungen/nachhaltigkeit") },
      { title: "Personaltage", href: getExternalUrl("/tagungen/personaltage") },
      {
        title: "Personalvertretungsrecht",
        href: getExternalUrl("/tagungen/personalvertretungsrecht"),
      },
      { title: "Sozialrecht SGB II", href: getExternalUrl("/tagungen/sozialrecht-sgb-ii") },
      {
        title: "Sozialrecht SGB IX (BTHG)",
        href: getExternalUrl("/tagungen/sozialrecht-sgb-ix-bthg"),
      },
      { title: "Sozialrecht SGB XII", href: getExternalUrl("/tagungen/sozialrecht-sgb-xii") },
      {
        title: "Staatsangehörigkeitsrecht",
        href: getExternalUrl("/tagungen/staatsangehoerigkeitsrecht"),
      },
      { title: "Steuerrecht", href: getExternalUrl("/tagungen/steuerrecht") },
      {
        title: "Unterhaltsvorschuss",
        href: getExternalUrl("/tagungen/unterhaltsvorschuss-tagung"),
      },
      { title: "Vergaberecht", href: getExternalUrl("/tagungen/vergaberecht") },
      { title: "Vollstreckungsrecht", href: getExternalUrl("/tagungen/vollstreckungsrecht") },
      { title: "Waffenrecht", href: getExternalUrl("/tagungen/waffenrecht") },
      {
        title: "Wirtschaftliche Jugendhilfe",
        href: getExternalUrl("/tagungen/wirtschaftliche-jugendhilfe"),
      },
      { title: "Zuwendungsrecht", href: getExternalUrl("/tagungen/zuwendungsrecht") },
    ],
    isOpen: false,
  },
  {
    title: "Service",
    href: getExternalUrl("/service"),
    children: [
      { title: "Partnerhotels", href: getExternalUrl("/service/partnerhotels") },
      { title: "Veranstaltungsorte", href: getExternalUrl("/service/veranstaltungsorte") },
      { title: "DB-Tickets", href: getExternalUrl("/service/db-tickets") },
      { title: "Anreise", href: getExternalUrl("/service/anreise") },
      { title: "Download", href: getExternalUrl("/service/download") },
      {
        title: "Förderung beruflicher Weiterbildung",
        href: getExternalUrl("/service/foerderung-weiterbildung"),
      },
      { title: "Häufig gestellte Fragen", href: getExternalUrl("/service/faqs") },
      { title: "Newsletter", href: getExternalUrl("/service/newsletter") },
      {
        title: "Peter Edel - Raumvermietung",
        href: getExternalUrl("/service/raum-mieten-peter-edel-berlin-weissensee"),
      },
    ],
    isOpen: false,
  },
  {
    title: "Über Uns",
    href: getExternalUrl("/ueber-uns"),
    children: [
      { title: "Unser Profil", href: getExternalUrl("/ueber-uns/vereins-profil") },
      { title: "Team", href: getExternalUrl("/ueber-uns/team") },
      { title: "Jobs und Karriere", href: getExternalUrl("/ueber-uns/jobs-und-karriere") },
      { title: "Zertifizierungen", href: getExternalUrl("/ueber-uns/zertifizierungen") },
      { title: "Leitbild", href: getExternalUrl("/ueber-uns/leitbild") },
      {
        title: "Bildungszentrum 'Peter Edel'",
        href: getExternalUrl("/ueber-uns/bildungszentrum-peter-edel"),
      },
      { title: "Kooperationen", href: getExternalUrl("/ueber-uns/kooperationen") },
      { title: "Dozententätigkeit", href: getExternalUrl("/ueber-uns/dozenten-bewerbung") },
    ],
    isOpen: false,
  },
  {
    title: "Meldungen",
    href: getExternalUrl("/aktuelles"),
    children: [],
    isOpen: false,
  },
];

export function Header() {
  const { authenticated, login, logout, keycloak } = useKeycloak();
  const [menuItems, setMenuItems] = useState<IMenuItem[]>(initialMenuItems);

  const renderNavbar = () => {
    return (
      <div className="row">
        <ul className="nav navbar-nav level-2">
          <li>
            <a href="/" className="start" title="Startseite"></a>
          </li>
          {menuItems.map((menuItem) =>
            menuItem.children && menuItem.children.length > 0 ? (
              <li
                id={menuItem.href}
                key={menuItem.href}
                className={`has-child dropdown ${
                  menuItem.isOpen ? "open" : ""
                }`}
                onClick={() =>
                  setMenuItems((prevMenuItems) =>
                    prevMenuItems.map((_menuItem) =>
                      _menuItem.href === menuItem.href
                        ? { ..._menuItem, isOpen: !_menuItem.isOpen }
                        : { ..._menuItem, isOpen: false }
                    )
                  )
                }
              >
                <a
                  className="dropdown-toggle text-uppercase"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  href={menuItem.href}
                >
                  {menuItem.title}
                </a>
                <span className="subpage-dropdown visible-xs-inline-block iconwechsel"></span>
                <ul className="sublevel level-3 dropdown-menu">
                  {menuItem.children?.map((child) => (
                    <li key={child.href}>
                      <a href={child.href}>{child.title}</a>
                    </li>
                  ))}
                </ul>
              </li>
            ) : (
              <li key={menuItem.href} className="has-child dropdown">
                <a href={menuItem.href} className="text-uppercase ">
                  {menuItem.title}
                </a>
              </li>
            )
          )}
        </ul>
        <ul className="nav navbar-nav navbar-jobs">
          <li>
            <a href="/ueber-uns/jobs-und-karriere">
              <i className="fa fa-rocket" aria-hidden="true"></i> Karriere
            </a>
          </li>
          {authenticated && (
            <li className="has-child dropdown" onMouseEnter={(e) => e.currentTarget.classList.add('open')} onMouseLeave={(e) => e.currentTarget.classList.remove('open')}>
              <a 
                href="/dashboard"
                className="dropdown-toggle"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="fa fa-th-large" aria-hidden="true"></i> Portal
              </a>
              <span className="subpage-dropdown visible-xs-inline-block iconwechsel"></span>
              <ul className="sublevel level-3 dropdown-menu">
                <li>
                  <a href="/seminare">Seminare</a>
                </li>
                <li>
                  <a href="/dashboard">Profil</a>
                </li>
              </ul>
            </li>
          )}
        </ul>
        <ul className="nav navbar-nav visible-xs-block">
          <li role="separator" className="divider"></li>
          <li>
            <a href="/Vormerkliste/">
              Vormerkliste <span className="badge">0</span>
            </a>
          </li>
          {authenticated && (
            <>
              <li className="has-child dropdown">
                <a href="/dashboard">
                  <i className="fa fa-th-large" aria-hidden="true"></i> Portal
                </a>
                <span className="subpage-dropdown visible-xs-inline-block iconwechsel"></span>
                <ul className="sublevel level-3 dropdown-menu">
                  <li>
                    <a href="/seminare">Seminare</a>
                  </li>
                  <li>
                    <a href="/dashboard">Profil</a>
                  </li>
                </ul>
              </li>
            </>
          )}
          <li role="separator" className="divider"></li>
          <li>
            {authenticated ? (
              <a href="#" onClick={(e) => { e.preventDefault(); logout(); }} rel="nofollow">
                <i className="fa fa-user"></i> Abmelden
              </a>
            ) : (
              <a href="#" onClick={(e) => { e.preventDefault(); login(); }} rel="nofollow">
                <i className="fa fa-user"></i> Login
              </a>
            )}
          </li>
        </ul>
      </div>
    );
  };

  return (
    <header>
      <div
        id="Head-Container"
        className="container-fluid farbmod-0 hidden-xs hidden-print"
      >
        <div className="row">
          <div className="container">
            <div className="col-sm-3">
              <div className="row">
                <div className="pull-left hidden-sm">
                  <i className="fa fa-phone" aria-hidden="true"></i> +49 (030)
                  29 33 50 0
                </div>
                <div className="pull-left hidden">
                  <a href="mailto:info@kbw.de" rel="nofollow">
                    <i className="fa fa-envelope" aria-hidden="true"></i>{" "}
                    info@kbw.de
                  </a>
                </div>
              </div>
            </div>
            <div className="col-sm-9 hidden-xs">
              <div className="col-xs-12">
                <div className="row">
                  <div>
                    <div className="pull-right">
                      {authenticated ? (
                        <a href="#" onClick={(e) => { e.preventDefault(); logout(); }}>
                          <i className="fa fa-user"></i> Abmelden ({keycloak?.tokenParsed?.preferred_username})
                        </a>
                      ) : (
                        <a href="#" onClick={(e) => { e.preventDefault(); login(); }}>
                          <i className="fa fa-user"></i> Dozenten-Login
                        </a>
                      )}
                    </div>
                  </div>
                  <div className="pull-right hidden">
                    <a
                      href="/Vormerkliste"
                      rel="nofollow"
                      title="favorisierte Weiterbildungen"
                    >
                      <i className="fa fa-bookmark" aria-hidden="true"></i>{" "}
                      meine Favoritenliste
                      <span>0</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav className="navbar nav-relative">
        <div className="container-fluid">
          <div className="row">
            <div className="container">
              <div className="row">
                <div className="col-xs-12 col-sm-3 col-md-2 text-center logo1">
                  <div>
                    <div className="col-xs-9 col-sm-12 col-md-12">
                      <a href="/" title="zur Startseite">
                        <img
                          className="pull-left img-responsive"
                          alt="Logo - KBW e. V."
                          src="/media/kbw-logo.svg"
                        />
                      </a>
                    </div>
                    <div className="visible-xs-2">
                      <button
                        type="button"
                        title="Menu"
                        className="navbar-toggle collapsed"
                        data-toggle="collapse"
                        data-target="#naviBar"
                        aria-controls="navbar"
                        aria-expanded="false"
                      >
                        <i className="fa fa-bars"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-9 col-md-10">
                  <div className="col-xs-12 col-sm-10 col-sm-offset-2 col-md-8 col-md-offset-3 pad-05 pull-right">
                    <div className="kopfsuche">
                      <div className="row">
                        <div className="col-xs-12 col-md-10 col-center">
                          <form
                            action="/seminare/suchen"
                            method="GET"
                            className="form-horizontal"
                          >
                            <div className="suchLeiste clearfix">
                              <div>
                                <div className="form-inline">
                                  <input
                                    type="text"
                                    className="input-lg form-control col-xs-10"
                                    placeholder="Was möchten Sie suchen?"
                                    name="search"
                                  />
                                </div>
                                <button
                                  type="submit"
                                  className="input-lg btn-primary col-xs-2"
                                  title="Suche starten"
                                >
                                  <span className="hidden-xs hidden-sm">
                                    Suchen
                                  </span>
                                  <span
                                    className="glyphicon glyphicon-search hidden-md hidden-lg"
                                    aria-hidden="true"
                                  ></span>
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="collapse navbar-collapse col-sm-12 pull-right"
                    id="naviBar"
                  >
                    {renderNavbar()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
